require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./wir-leben-uns-ein.json") })
        }
      }, "path---wir-leben-uns-ein");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---wir-leben-uns-ein!./.cache/json/wir-leben-uns-ein.json
// module id = 437
// module chunks = 231608221292675